<template>
  <div>
    <v-row no-gutters justify="center" class="mb-5">
      <h6 class="text-h6">{{ header }}</h6>
    </v-row>
    <v-row no-gutters justify="center">
      <upload-page-placeholder
        v-if="showPageLevelUploader"
        v-model="file"
        prompt="Drag &amp; drop full-text PDF"
        :accept="['.pdf']"
        @input="$emit('upload')"
        @invalid="invalidFileError = true"
      />
      <full-text-pdf-dropzone
        v-else
        v-model="file"
        class="mt-2"
        @input="$emit('upload')"
        @invalid="invalidFileError = true"
      />
    </v-row>
    <upload-progress-bar
      v-if="file"
      :file-name="file.name"
      :progress="progress"
      @cancel="onCancel"
    />
    <v-row
      v-if="invalidFileError"
      no-gutters
      justify="center"
      class="caption error--text py-4"
    >
      Please select a PDF file, other file types are not supported.
    </v-row>
  </div>
</template>

<script>
import UploadPagePlaceholder from '@/components/Common/UploadPagePlaceholder';
import UploadProgressBar from '@/components/Common/UploadProgressBar';
import FullTextPdfDropzone from './FullTextPdfDropzone';

export default {
  name: 'FullTextPdfUploader',
  components: {
    UploadPagePlaceholder,
    UploadProgressBar,
    FullTextPdfDropzone,
  },
  props: {
    value: {
      type: [File, Object],
      default: null,
    },
    progress: {
      type: Number,
      default: 0,
    },
    pageLevel: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({ invalidFileError: false }),
  computed: {
    file: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        if (value) {
          this.invalidFileError = false;
        }
        this.$emit('input', value);
      },
    },
    header() {
      return this.file ? 'Uploading...' : 'Upload full-text PDF';
    },
    showPageLevelUploader() {
      return !this.file && this.pageLevel;
    },
  },
  methods: {
    onClear() {
      this.file = null;
    },
    onCancel() {
      this.onClear();
      this.$emit('cancel');
    },
  },
};
</script>
